import { render, staticRenderFns } from "./CustomPopover.vue?vue&type=template&id=1797a9b6"
import script from "./CustomPopover.vue?vue&type=script&lang=js"
export * from "./CustomPopover.vue?vue&type=script&lang=js"
import style0 from "./CustomPopover.vue?vue&type=style&index=0&id=1797a9b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports